import React from "react";
import LocalizedWeatherGuidePage from "@/components/weather/LocalizedWeatherGuidePage";

export default function TideGuide() {
  return <LocalizedWeatherGuidePage guideKey="tide" />;
}